import { find } from 'lodash';

export const resolveProperties = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'propertiesService', propertiesService => {
    return propertiesService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolveProperty = (param = 'property') => {
  return [ '$stateParams', 'propertiesService', ($stateParams, propertiesService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? propertiesService.findById($stateParams[param]) : {};
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/resolvers/properties.resolver.js